const changeResponseToArrayMap = (list, labelName, valueName) => {
  if (list && list.length > 0) {
    const newList = list.map((el) => { return { label: el[labelName], value: el[valueName] } } );

    return newList
  }
  return []
}

export default changeResponseToArrayMap;